import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant from '../../Constant'
import Moment from 'react-moment'
import HasPermission from '../../common/Permissions/HasPermission'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Select from 'react-select'
import moment from 'moment'
import Button from '../../common/CustomComponents/Button'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class EventCompaniesList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    isEditing: false,

    keyword: '',
    price: '',
    categoryData: null,
    categoryList: [],
    pickupData: null,
    pickupList: [],
    date: '',
    to_date: '',
    minToDate: moment().format('YYYY-MM-DD'),
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
  }

  debounceTimeout = null

  componentDidMount() {
    this.getCategories()
    this.getPickup()
    this.dashbord()
  }

  dashbord = async () => {
    this.setState({
      isloading: true,
      Products_data: [],
    })

    await axios
      .get(Constant.getAPI() + `/event-companies/list-event-companies/ALL`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,
          price: this.state.price,
          category: this.state.categoryData?.value,
          pickup: this.state.pickupData?.value,
          date: this.state.date,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            Products_data: res.data?.data,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isloading: false,
        })
      })
  }

  getPickup = async () => {
    this.setState({ isloading: true })
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            pickupList: res?.data?.data?.map((ele) => {
              return { label: `${ele.pickup_address_en}/${ele.pickup_address_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false })
      })
  }

  getCategories = async () => {
    this.setState({ isloading: true })
    await axios
      .get(Constant.getAPI() + `/event-categories/list-event-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            categoryList: res?.data?.data?.map((ele) => {
              return { label: `${ele.category_name_en}/${ele.category_name_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isloading: false })
      })
  }

  handleStatusChange = async (id, isActive) => {
    var data = {
      id: id,
      is_active: isActive,
    }
    await axios
      .put(Constant.getAPI() + '/event-companies/update-company-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.dashbord()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onEdit = (selectedId, order) => {
    this.setState({ isEditing: true, selectedId, order })
  }

  onInputChange = (e) => {
    e.persist()
    const fieldName = e?.target?.name
    const fieldValue = e?.target?.value

    this.setState({
      [fieldName]: fieldValue,
    })

    // Auto-search with debounce for keyword field
    if (fieldName === 'keyword') {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

      this.debounceTimeout = setTimeout(() => {
        this.setState(
          {
            pageNumber: 0,
          },
          () => {
            this.dashbord()
          }
        )
      }, 500)
    }
  }

  onChangeOrder = (selectedId) => {
    this.setState({ isEditing: false })

    var data = {
      id: selectedId,
      order: parseInt(this.state.order),
    }

    axios
      .put(Constant.getAPI() + '/event-companies/edit-event-company', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((data) => {
        if (data.status === 200 && data.data) {
          let tempList = this.state.Products_data

          tempList.forEach((item) => {
            if (item.id === selectedId) {
              item.order = this.state.order
            }
          })

          this.setState({
            Products_data: tempList,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteEventCompany = (id) => {
    Swal.fire({
      title: 'Are you sure to delete this Event Company?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

        axios
          .delete(Constant.getAPI() + `/event-companies/delete-event-company/${id}`, {
            headers: {
              Authorization: token,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              toast: true,
              icon: 'success',
              position: 'top-end',
              title: 'Deleted Successfully!',
              showConfirmButton: false,
              timerProgressBar: true,
              timer: 2500,
            })
            this.dashbord()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  clearFilters = () => {
    this.setState(
      {
        facilityData: [],
        categoryData: null,
        pickupData: null,
        date: '',
        keyword: '',
        price: '',
        limit: 10,
        pageNumber: 0,
        Products_data: [],
      },
      () => {
        this.dashbord()
      }
    )
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.dashbord()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.dashbord()
      }
    )
  }

  handleCategoryClear = () => {
    this.setState({ categoryData: {} })
  }

  handlePickupClear = () => {
    this.setState({ pickupData: {} })
  }

  handleCategoryChange = (event) => {
    this.setState({
      categoryData: event,
    })
  }

  handlePickupChange = (event) => {
    this.setState({
      pickupData: event,
    })
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'id',
        options: {
          display: false,
        },
      },
      {
        name: 'company_img_url',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (company_img_url) => {
            return (
              <div>
                {company_img_url !== null ? (
                  <div>
                    {company_img_url?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                              ? Constant.getImage() + company_img_url
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                            ? Constant.getImage() + company_img_url
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                        ? Constant.getImage() + company_img_url
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'company_name_en',
        label: 'Company Name: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return <>{date || '--'}</>
          },
        },
      },
      {
        name: 'company_name_ar',
        label: 'Company Name: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return <>{date || '--'}</>
          },
        },
      },
      {
        name: 'company_short_name_en',
        label: 'Company Short Name: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'updatedAt',
        label: 'Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'updatedAt',
        label: 'Time(hrs:min:sec)',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="HH:mm:ss">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeOrder.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active, 'isActive')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'View Events',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/view-event-company/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Events "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Contract Files',
        options: {
          filter: false,
          sort: false,
          display: HasPermission('contract-files'),
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/contract-files/event/${id}`}
                  className="m-r-15 text-muted"
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'View Gallery',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/gallary-list/event-company/${id}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Events "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div class="d-flex align-items-center">
                <Link
                  to={`/event-companies/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteEventCompany.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.dashbord()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.dashbord()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isloading ? <Loader open={this.state.isloading} /> : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Event Company List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/event-companies/add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    <i className="icofont icofont-plus m-r-5"></i> Add Event Company
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Company List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="keyword"
                              className="form-control"
                              value={this.state.keyword}
                              name="keyword"
                              placeholder="Name | Description | Owner"
                              // onKeyPress={this.handleKeyPress}
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Category</label>
                          <div className="col-sm-9">
                            <Select
                              name="categoryData"
                              value={this.state.categoryData}
                              onChange={this.handleCategoryChange}
                              options={this.state.categoryList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleCategoryClear}
                              placeholder="Select Option"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Pick Up</label>
                          <div className="col-sm-9">
                            <Select
                              name="pickupData"
                              value={this.state.pickupData}
                              onChange={this.handlePickupChange}
                              options={this.state.pickupList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handlePickupClear}
                              placeholder="Select Option"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Price search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="price"
                              className="form-control"
                              value={this.state.price}
                              name="price"
                              placeholder="Price"
                              // onKeyPress={this.handleKeyPress}
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Date</label>
                          <div className="col-md-9">
                            <input
                              type="date"
                              min={moment().format('YYYY-MM-DD')}
                              id="date"
                              className="form-control"
                              value={this.state.date}
                              name="date"
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4"></div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <div className="text-left col">
                            <Button
                              onClick={this.dashbord}
                              disabled={this.state.isloading}
                            >
                              {this.state.isloading ? 'Searching...' : 'Search'}
                            </Button>
                            <Button
                              variant={'outlined'}
                              onClick={this.clearFilters}
                            >
                              Clear
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`Event Company List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventCompaniesList
